import React from 'react';
import { PiInfinity } from 'react-icons/pi';
import { EMPTY_VALUE_PLACEHOLDER } from '../const/system';
import { renderDatetimeColumnWithUtcZeroTimeBool } from './renderDatetimeColumnWithUtcZeroTimeBool';



export const renderReleasedToColumn = (value, item) => {
  if (!item.released_to) {
    return item.released_at && item.is_published ? <PiInfinity /> : <span>{EMPTY_VALUE_PLACEHOLDER}</span>;
  }

  return renderDatetimeColumnWithUtcZeroTimeBool(value, item, 'released_to');
};
